import React, { useEffect, useState } from "react";
import { Paper, LinearProgress, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import styled from "styled-components";
import API from "../../axios/instances/API";

const Card = styled(Paper)`
  min-height: 300px;
  width: calc(min(400px, 96vw));
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  padding: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const HighlightLink = styled(Link)`
  color: ${(props) => props.theme.palette.info.light};
  font-weight: 600;
  font-size: 14px;
`;

const WideLinear = styled(LinearProgress)`
  min-width: 100%;
`;

const VerifyEmail = ({ match }) => {
  const [isVerifying, setIsVerifying] = useState(true);
  const [returnText, setReturnText] = useState("");
  const { token } = match.params;

  useEffect(() => {
    const verify = async () => {
      try {
        await API.post("/dashboard/account/verify/", {
          token,
        });
        setIsVerifying(false);
        return setReturnText("Account Verified");
      } catch (error) {
        setIsVerifying(false);
        const { msg } = error.response.data;
        if (msg === "invalid_token") {
          return setReturnText("Your Token is Invalid");
        }
        if (msg !== "invalid_token") {
          return setReturnText("Issue has Occured");
        }
        return undefined;
      }
    };
    return verify();
  }, []);

  return (
    <Wrapper>
      <Card>
        <Typography variant="h3" align="center" sx={{ mb: 2 }}>
          {isVerifying ? "Verifying Your Account.." : returnText}
        </Typography>
        {isVerifying && <WideLinear variant="indeterminate" color="primary" />}
        {returnText === "Account Verified" && (
          <Typography variant="body2">
            Feel free to <HighlightLink to="/">Sign In</HighlightLink>
          </Typography>
        )}
        {returnText && returnText !== "Account Verified" && (
          <Typography variant="body2">
            Please Retry Signup Process{" "}
            <HighlightLink to="/register">Here</HighlightLink>
          </Typography>
        )}
      </Card>
    </Wrapper>
  );
};

export default VerifyEmail;
